import { useCallback, useState } from "react";
import TspApiService from "../../../api/tspApiService";
import useTspApiResource from "../../../hooks/useTspApiResource";

const NOTHING = () => Promise.resolve({ data: null });

// The book catalog for Book Distribution forms, read only once a form asks for
// it (`request()`), not for every page that could show one.
export default function useLazyBookCatalog() {
  const [requested, setRequested] = useState(false);
  const catalog = useTspApiResource(() => (requested && typeof TspApiService.getBookCatalog === "function" ? TspApiService.getBookCatalog() : NOTHING()), [requested]);
  const request = useCallback(() => setRequested(true), []);
  return { ...catalog, request };
}
